module.exports = __webpack_public_path__ + "img/map.ede8b4f0.png";